export default __webpack_public_path__ + "img/component-info-card.0ee24669.png";